 const ButtonType = {
    PRIMARY:"primary",
    SECONDARY:"secondary",
    TERTIARY:"tertiary"
}
Object.freeze(ButtonType);

export default ButtonType